import { AssignmentRole } from '../../../utils/internalAssignments';

const texts = {
  internalAssignments: 'Internal Assignments',
  tabLabels: {
    [AssignmentRole.INSIDE_SALES]: 'IS Assignments',
    [AssignmentRole.ASSISTANT_COACH]: 'AC/Pool Assignment',
    [AssignmentRole.CAM]: 'CAM Assignments',
    [AssignmentRole.CPS]: 'CPS Assignments',
  },
  tableColumns: {
    user: 'User',
    userId: 'User ID',
    createdAt: 'Created At',
    actions: 'Actions',
  },
  addAssignment: 'Add Assignment',
  addLiaison: 'Add Liaison',
  removeAssignment: 'Remove Assignment',
  removeAssignmentTitle: 'Are you sure you want to remove this assignment?',
  podBlockedRemovalDescription: '{user} — pods are enabled for this coach, so they cannot be moved to the pool. '
    + 'Removing this assignment leaves them with no AC.',
  assignmentRemovalFailed: 'Failed to remove assignment. Error: {error}',
  liaisonAcName: '{acName} (Liaison)',
  podsBlocked: 'Pods are enabled for {coaches}. The AC to pod link lives on the assignment row, so pooling them would '
    + 'break their pod rebalance. Remove their pods first.',
  acNotEnabledBlocked: 'Assistant Coaching is not enabled for {coaches}, so they cannot be moved to the pool. Turn on '
    + 'Assistant Coaching in their coach settings first.',
  podCheckFailed: 'Failed to check pod settings. Error: {error}',
  coachesAddedToPool: 'Moved to the pool',
  partialMoveToPool: '{count} of {total} coaches were moved to the pool before the move failed. The rest are '
    + 'unchanged — retry to move them.',
  alreadyPooled: '{coaches} were already in the pool, so nothing changed for them.',
  addToPoolFailed: 'Failed to move to the pool. Error: {error}',
  activeClientsLoadFailed: 'Failed to load active client counts. Error: {error}',
  unknownCoach: '—',
  viewPool: 'View Pool · {count}',
  moveToPool: 'Move to Pool',
  removeFromPool: 'Remove from Pool',
  coachRemovedFromPool: '{coach} now has a dedicated AC and has left the pool',
  poolLoadFailed: 'Failed to load the coach pool. Pool actions stay unavailable until it loads, including removing a '
    + "coach's last AC — use Retry Loading Pool. Error: {error}",
  retryPoolLoad: 'Retry Loading Pool',
};

export default texts;
